import { PortableTextBlock } from '@portabletext/react';
import { createClient } from '@sanity/client';

import config from '@rikstv/play-common/src/config';

/**
 * Resources:
 * - https://www.sanity.io/docs/query-cheat-sheet
 * - https://www.sanity.io/docs/js-client
 */

export const sanityClient = createClient({
  projectId: 'bj7ifs6s',
  dataset: config.sanityDataset,
  apiVersion: '2024-08-01',
  useCdn: true,
});

/**
 * Returns last five strimetips based on "dateWritten" field that is updated manually by editors
 */
export const getLastPublishedStrimetips = async () => {
  return await sanityClient.fetch<StrimetipsResponse>(`
     *[_type == "strimetipsArticle"][listContent.visible==true]
     | order(listContent.dateWritten desc)
     {
       slug,
       category->{name},
       listContent{
         dateWritten,
         title,
         description,
         image{asset->{url,altText}}
       }
     }[0..4]`);
};

type StrimetipsResponse = Array<{
  listContent: {
    image: {
      asset: { url: string; altText: string };
    };
    title: string;
    description: string;
    dateWritten: string;
  };
  category: { name: string };
  slug: { current: string };
}>;

export const getLandingPageContent = async () => {
  return await sanityClient.fetch<StrimStartPageResponse>(`
    *[_type == "strimStartPage"][0]{
      ...,
      "heroImageUrl": heroImage.asset->url,
      plug{
        ...,
        "plugImageUrl": plugImage.asset->url,
      },
      devicePromo{
        ...,
        "devicePromoImageUrl": devicesPromoImage.asset->url,
      },
    }
  `);
};

export type StrimStartPageResponse = {
  title: string;
  primaryCTA: {
    text: string;
    link: string;
  };
  secondaryCTA: {
    text: string;
    link: string;
  };
  tertiaryCTA: {
    text: string;
    link: string;
  };
  ingress: PortableTextBlock[];
  heroImageUrl: string;
  sellingPoints: {
    argument1: string;
    argument2: string;
    argument3: string;
  };
  plug: {
    plugImageUrl: string;
    plugTitle: string;
    plugText: PortableTextBlock[];
    plugButton: {
      text: string;
      link: string;
    };
  };
  devicePromo: {
    devicePromoImageUrl: string;
    title: string;
    text: PortableTextBlock[];
  };
};
